export const haloEffectVerticalVariant = {
    DESKTOP: 'halo-effect-vertical-desktop',
    MOBILE: 'halo-effect-vertical-mobile',
};
export const verticalType = {
    games: 'games',
    movies: 'movies',
    tv: 'tv',
    anime: 'anime',
};
export const verticalTypes = Object.values(verticalType);
